import * as React from 'react';
import * as styles from './index.css';

export function License() {
  return(
    <div className={styles['license']}>
      <span>При подписке вы принимаете условия </span>
      <a 
        className={styles['license-link']}
        target="_blank" 
        rel="nofollow"
        href="//www.cian.ru/help/about/rules/"
      >
        Пользовательского соглашения
      </a>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/bundles/common/components/subscription_form/license/index.tsx